module.exports = __webpack_public_path__ + "img/trash.3a0d0fba.svg";